export const defaultUser = {
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  marketingConsent: false,
  shippingAddress: {},
  billingAddress: {},
};

export const defaultDeliveryFee = 2.99;
export const defaultDiscount = "FRESH20";

export const defaultDelivery = {
  deliveryFee: defaultDeliveryFee,
};

export const defaultSubscription = {
  discount: defaultDiscount,
};

export enum SignupFlowSlug {
  // Cat pages
  BASIC_INFORMATION = "/sign-up/fresh/basic-information",
  AGE = "/sign-up/fresh/age",
  EATING_HABITS = "/sign-up/fresh/eating-habits",
  MOTIVATION = "/sign-up/fresh/motivation",
  ACTIVITY_LEVELS = "/sign-up/fresh/activity-levels",
  WEIGHT = "/sign-up/fresh/weight",
  CURRENT_DIET = "/sign-up/fresh/current-diet",
  MEDICAL_CONDITIONS = "/sign-up/fresh/medical-conditions",
  ALLERGIES = "/sign-up/fresh/allergies",

  // User pages
  CAT_PARENT_DETAILS = "/sign-up/fresh/cat-parent-details",
  CHECKOUT = "/sign-up/fresh/checkout",
  PRICING = "/sign-up/fresh/pricing",

  // Pages with no validation
  RECIPES = "/sign-up/fresh/recipes",
  TREATS = "/sign-up/fresh/treats",
}
